import {FormDefinitionGroupFieldModel} from './formDefinitionGroupField.model';

export class FormDefinitionGroupModel {
    label: string;
    index: number;
    fields: FormDefinitionGroupFieldModel[] = [];
    contextValue: string;
    fullWidth: boolean;
    nbColumns: number;
    color: string;
}
